export default __webpack_public_path__ + "media/images/congratulations-bg-99d9a07c.png";